import { RouterPathes } from './router-paths'

export const PAGE_TITLE_BY_ROUTE_MAP: { [key: string]: string } = {
  [RouterPathes.games]: 'Games',
  [RouterPathes.priceFormulation]: 'Price formulation',
  [RouterPathes.fundingPayments]: 'Funding payments',
  [RouterPathes.settings]: 'Settings',
  [RouterPathes.profile]: 'Profile',
  [RouterPathes.notifications]: 'Notifications',
  [RouterPathes.passwordRecovery]: 'Password recovery',
  [RouterPathes.rewards]: 'Rewards',
  [RouterPathes.help]: 'Help',
  [RouterPathes.onboarding]: 'Onboarding',
  [RouterPathes.onboardingBullsEye]: 'Onboarding',
  [RouterPathes.onboardingOneVsOne]: 'Onboarding',
  [RouterPathes.onboardingReferralProgram]: 'Onboarding',
  [RouterPathes.onboardingRewardsSystem]: 'Onboarding',
  [RouterPathes.onboardingSetups]: 'Onboarding',
  [RouterPathes.onboardingTreasure]: 'Onboarding',
  [RouterPathes.onboardingUpDown]: 'Onboarding',
  [RouterPathes.onboardingMemeWars]: 'Onboarding',
  [RouterPathes.termsAndConditions]: 'Terms and Conditions',
  [RouterPathes.privacyPolicy]: 'Privacy Policy',
  [RouterPathes.termsOfService]: 'Terms of Service',
  [RouterPathes.amlPolicy]: 'AML policy',
  [RouterPathes.oAuth]: 'Auth',
  [RouterPathes.unlogged]: 'Unlogged',
  [RouterPathes.about]: 'About',
  [RouterPathes.referrals]: 'Referrals',
  [RouterPathes.buyback]: 'Token',
  [RouterPathes.buybackBridge]: 'Bridge',
  [RouterPathes.buybackSwap]: 'Trade',
  [RouterPathes.buybackHolders]: 'Holders',
  [RouterPathes.home]: 'Home'
}
